import React from 'react';
import { Dialog } from '@shared/components';
import { DialogContent, DialogTitle, Stack } from '@mui/material';
import { ChangelogEntry } from './ChangelogEntry';
import { useChangelogTFunction } from '@retail/changelog/i18n';
import { ChangelogEntry as ChangelogEntryType } from '@retail/changelog/types';

interface Props {
  entries: ChangelogEntryType[];
  onClose: () => void;
  open?: boolean;
}

export const ChangelogEntriesDialog: React.FC<Props> = ({ entries, onClose, open = true }) => {
  const t = useChangelogTFunction();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      slotProps={{ paper: { sx: { borderRadius: 4 } } }}
    >
      <DialogTitle sx={{ paddingBottom: 1 }}>{t('changelog.recentChanges.title')}</DialogTitle>
      <DialogContent
        sx={{
          paddingX: 0,
          paddingBottom: 0,
          borderBottomLeftRadius: 'inherit',
          borderBottomRightRadius: 'inherit',
        }}
      >
        <Stack sx={{ '& > *:nth-of-type(odd)': { backgroundColor: 'grey.50' } }}>
          {entries.map((entry) => (
            <ChangelogEntry key={entry.id} {...entry} />
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
